<template>
  <div class="p-0 mb-50">
    <div class="mt-30 container-style mb-30">
      <div class="p-20 activity-form">
        <div class="create-edit-packet-page" id="create-edit-packet-page">
          <div>
            <div class="d-flex p-20 fs-16">
              <router-link v-if="$route.name == 'study-create-edit-packet'" :to="{ name: 'study-activities', params: { studyId } }">Activities&nbsp;</router-link>
              <router-link v-else :to="{ name: 'forms-list', params: { studyId } }">Data Capture Forms&nbsp; </router-link>
              <span>/ Edit Packet</span>
            </div>

            <div class="col-md-3 pl-20">
              Name
              <span class="required">*</span>
            </div>
            <div class="col-md-3 pl-20">
              <input type="text" class="packet-name-box pl-5 mt-5" placeholder="Enter packet name" v-model="packetName" maxlength="100" />
            </div>

            <div class="row">
              <div class="pl-20 pt-15 pr-40 col-12">
                <div class="tableBg1">
                  <b-row>
                    <b-col cols="10" class="p-0">
                      <h6>
                        <span class="noOfFormsText">Order Forms</span>
                      </h6>
                    </b-col>
                    <b-col cols="2" class="p-0 text-right">
                      <b-form-select v-model="selectedShowOption" :options="scheduleFormOptions" class="mb-3 fs-12 downArrow" size="sm" @change="showForms" />
                    </b-col>
                  </b-row>
                </div>
                <template>
                  <table class="tableBg2 create-edit-packet-page__order-table">
                    <thead>
                      <tr>
                        <th class="p-0" width="5%"></th>
                        <th class="p-0" width="25%">Name</th>
                        <th class="p-0" width="21%">Type</th>
                        <th class="p-0" width="8%">Created By</th>
                        <th class="p-0" width="8%">Group</th>
                        <th class="p-0" width="7%">Steps</th>
                        <th class="p-0" width="8%">Duration</th>
                        <th class="p-0" width="6%">Languages</th>
                        <th class="p-0" width="10%">Last Modified</th>
                        <th class="p-0" width="3%"></th>
                      </tr>
                    </thead>
                    <draggable v-if="currentFormList.length > 0" v-model="currentFormList" @start="drag = true" @end="onDragEnd" tag="tbody" handle=".handle">
                      <tr v-for="(form, index) in currentFormList" :key="index">
                        <td class="p-0 drag-icon-container" width="5%">
                          <svg xmlns="http://www.w3.org/2000/svg" class="Vector mt-5 handle" width="25" height="25" fill="none" viewBox="0 0 15 25">
                            <path
                              id="a"
                              d="M4,15h16c0.553,0,1,0.447,1,1s-0.447,1-1,1H4c-0.552,0-1-0.447-1-1S3.448,15,4,15z M4,11h16
				                    c0.553,0,1,0.448,1,1c0,0.553-0.447,1-1,1H4c-0.552,0-1-0.447-1-1C3,11.448,3.448,11,4,11z M4,7h16c0.553,0,1,0.448,1,1
				                    s-0.447,1-1,1H4C3.448,9,3,8.552,3,8S3.448,7,4,7z"
                            />
                          </svg>
                        </td>
                        <td class="form-name p-0">
                          <label>
                            <span class="form-name">
                              <router-link
                                class="color_4c8ce4"
                                v-if="form.type == 'EDC'"
                                :to="{
                                  name: 'study-form-view',
                                  params: { formId: form.id }
                                }"
                                >{{ form.name }}</router-link
                              >
                              <router-link
                                class="color_4c8ce4"
                                v-if="form.type != 'EDC'"
                                :to="{
                                  name: 'study-activity-form-view',
                                  params: { formId: form.id }
                                }"
                                >{{ form.name }}</router-link
                              >
                            </span>
                          </label>
                        </td>
                        <td class="form-text activity_type mt-7 p-0">
                          <span>{{ form.type }}</span>
                        </td>
                        <td class="p-0">{{ form.createdBy }}</td>
                        <td class="p-0">{{ form.groupName }}</td>
                        <td class="p-0">{{ form.stepsCount }}</td>
                        <td class="p-0">{{ form.timeToComplete }}</td>
                        <td class="p-0">
                          <span class="create-edit-packet-table__language-box" :id="`selected-${form.id}-language`" tabindex="0">
                            {{ (form.language && form.language.length) || 0 }}
                          </span>
                          <b-popover :target="`selected-${form.id}-language`" triggers="click blur" placement="left" container="create-edit-packet-page">
                            <div class="create-edit-packet-table__language-pop-over-container" v-if="form.language && form.language.length">
                              <ul class="create-edit-packet-table__languages-list">
                                <li class="create-edit-packet-table__languages-list-item" v-for="(language, index) in getSortedLanguage(form.language)" :key="index">
                                  {{ language.display_name }}
                                </li>
                              </ul>
                            </div>
                          </b-popover>
                        </td>
                        <td class="p-0 date-text">
                          {{ getLastModifiedTime(form) }}
                        </td>
                        <td class="p-0" @click="removeFormFromSelectedForms(form)">
                          <img src="static/img/delete.svg" class="remove-form-icon" />
                        </td>
                      </tr>
                    </draggable>

                    <tr v-else>
                      <td colspan="10" align="center">
                        No forms selected for this packet. Add a form.
                      </td>
                    </tr>
                  </table>
                </template>
                <div class="tableBg3 mb-25">
                  <b-row class="pt-20">
                    <div @click="prevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage <= 1 }">
                      <i class="fa fa-angle-left fs-23"></i>
                    </div>
                    <div class="pagination">{{ currentPage }}</div>
                    <div class="pagination2">of {{ totalPages }}</div>
                    <div @click="nextPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: currentPage >= totalPages }">
                      <i class="fa fa-angle-right fs-23"></i>
                    </div>
                  </b-row>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="unselectedFormDisplay">
            <div class="pl-20 pt-0 pr-20 col-12">
              <div class="tableBg1">
                <b-row>
                  <b-col cols="10" class="pl-0 pr-20 col-10">
                    <h6>
                      <span class="noOfForms">{{ selectedFormsData.length }}</span>
                      <span class="noOfFormsText">Forms Selected</span>
                    </h6>
                  </b-col>
                  <b-col cols="2" class="p-0 text-right">
                    <b-form-select v-model="unSelectedShowOption" :options="unScheduleFormOptions" class="mb-3 fs-12 downArrow" size="sm" @change="unselectedShowForms" />
                  </b-col>
                </b-row>
              </div>
              <template>
                <table class="tableBg1 forms-table create-edit-packet-page__add-forms-table">
                  <thead>
                    <tr>
                      <th class="p-0" width="5%"></th>
                      <th class="p-0 cursor-pointer" width="24%" @click="toggleSortForUnselectedFormData('name')">
                        Name
                        <span class="sortUp" @click="sortUnselectedFormData('name', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('name', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0 cursor-pointer" width="8%" @click="toggleSortForUnselectedFormData('type')">
                        Type
                        <span class="sortUp" @click="sortUnselectedFormData('type', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('type', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0" width="19%">
                        Scheduled
                      </th>
                      <th class="p-0 cursor-pointer" width="8%" @click="toggleSortForUnselectedFormData('createdBy')">
                        Created By
                        <span class="sortUp" @click="sortUnselectedFormData('createdBy', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('createdBy', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0 cursor-pointer" width="7%" @click="toggleSortForUnselectedFormData('groupName')">
                        Group
                        <span class="sortUp" @click="sortUnselectedFormData('groupName', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('groupName', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0 cursor-pointer" width="7%" @click="toggleSortForUnselectedFormData('stepsCount')">
                        Steps
                        <span class="sortUp" @click="sortUnselectedFormData('stepsCount', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('stepsCount', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0 cursor-pointer" width="7%" @click="toggleSortForUnselectedFormData('timeToComplete')">
                        Duration
                        <span class="sortUp" @click="sortUnselectedFormData('timeToComplete', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('timeToComplete', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                      <th class="p-0" width="6%">Languages</th>
                      <th class="p-0 cursor-pointer" width="10%" @click="toggleSortForUnselectedFormData('modifiedTime')">
                        Last Modified
                        <span class="sortUp" @click="sortUnselectedFormData('modifiedTime', 'ASC')">
                          <i class="fa fa-angle-up" aria-hidden="true"></i>
                        </span>
                        <span class="sortDown" @click="sortUnselectedFormData('modifiedTime', 'DESC')">
                          <i class="fa fa-angle-down" aria-hidden="true"></i>
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(form, index) in unselectedCurrentFormList" :key="index">
                      <td class="p-0" style="text-align: center">
                        <input type="checkbox" :id="form.id" :checked="isFormSelected(form.id)" @change="getFormCount(form)" />
                      </td>
                      <td>
                        <span class="form-name">
                          <router-link
                            v-if="form.type == 'EDC'"
                            :to="{
                              name: 'form-view',
                              params: { formId: form.id }
                            }"
                            class="color_4c8ce4"
                            >{{ form.name }}</router-link
                          >
                          <router-link
                            v-if="form.type != 'EDC'"
                            :to="{
                              name: 'activity-form-view',
                              params: { formId: form.id }
                            }"
                            class="color_4c8ce4"
                            >{{ form.name }}</router-link
                          >
                        </span>
                      </td>
                      <td class="form-text p-0 activity_type">
                        <span>{{ form.type }}</span>
                      </td>
                      <td class="form-text p-0">
                        <template v-if="form.milestones && form.milestones.length > 0"> </template>
                      </td>
                      <td class="p-0">{{ getMilestoneNamesString(form) }}</td>
                      <td class="p-0">{{ form.createdBy }}</td>
                      <td class="p-0">{{ form.groupName }}</td>
                      <td class="p-0">{{ form.stepsCount }}</td>
                      <td class="p-0">{{ form.timeToComplete }}</td>
                      <td class="p-0">
                        <span class="create-edit-packet-table__language-box" :id="`unselected-${form.id}-language`" tabindex="0">
                          {{ (form.language && form.language.length) || 0 }}
                        </span>
                        <b-popover :target="`unselected-${form.id}-language`" triggers="click blur" placement="left" container="create-edit-packet-page">
                          <div class="create-edit-packet-table__language-pop-over-container" v-if="form.language && form.language.length">
                            <ul class="create-edit-packet-table__languages-list">
                              <li class="create-edit-packet-table__languages-list-item" v-for="(language, index) in getSortedLanguage(form.language)" :key="index">
                                {{ language.display_name }}
                              </li>
                            </ul>
                          </div>
                        </b-popover>
                      </td>
                      <td class="p-0 date-text">
                        {{ getLastModifiedTime(form) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>

              <div class="tableBg3 mb-15">
                <b-row class="pt-20">
                  <div @click="unselectedPrevPage" class="arrow-icon cursor_pointer" :class="{ disabledPagination: unselectedCurrentPage <= 1 }">
                    <i class="fa fa-angle-left fs-23"></i>
                  </div>
                  <div class="pagination">{{ unselectedCurrentPage }}</div>
                  <div class="pagination2">of {{ unselectedTotalPages }}</div>
                  <div
                    @click="unselectedNextPage"
                    class="arrow-icon cursor_pointer"
                    :class="{
                      disabledPagination: unselectedCurrentPage >= unselectedTotalPages
                    }"
                  >
                    <i class="fa fa-angle-right fs-23"></i>
                  </div>
                </b-row>
              </div>
            </div>
          </div>

          <div>
            <div class="pl-20" v-if="unselectedFormDisplay == false">
              <button type="button" class="buttons btn fs-12 primaryBgColor btn-primary btn-sm add-form" @click="addAForm()">
                Add a form
              </button>
            </div>

            <div class="pr-40 col-md-6 bt-pos pb-10 text-right">
              <span v-if="unselectedFormDisplay == false">
                <router-link v-if="$route.name == 'study-create-edit-packet'" :to="{ name: 'study-create-packet', params: { studyId } }" class="mr-20 color_4c8ce4">Cancel&nbsp; </router-link>
                <router-link v-else :to="{ name: 'forms-list', params: { studyId } }" class="mr-20 color_4c8ce4">Cancel&nbsp;</router-link>
              </span>
              <span v-else class="mr-20 color_4c8ce4 cursor-pointer" @click="onCancelAddingForms">Cancel</span>
              <span v-if="unselectedFormDisplay">
                <button type="button" class="buttons btn fs-12 primaryBgColor btn-primary btn-sm" @click="addRemainingForm">
                  Add Form
                </button>
              </span>
              <span v-else>
                <button type="button" class="buttons btn fs-12 primaryBgColor btn-primary-save btn-sm" @click="onSaveAndExit" v-if="unselectedFormDisplay == false">
                  Save and Exit
                </button>
              </span>
              <span>
                <button type="button" class="buttons btn ml-20 fs-12 primaryBgColor btn-primary btn-sm" @click="onSaveAndSchedule()" v-if="unselectedFormDisplay == false">
                  Save and Schedule
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import orderBy from "lodash/orderBy";
import sortBy from "lodash/sortBy";
import toastr from "toastr";
import draggable from "vuedraggable";
import _ from "lodash";

import ceil from "lodash/ceil";
import slice from "lodash/slice";

import { mapActions } from "vuex";

import moment from "moment";

export default {
  name: "create-edit-packet",
  components: {
    draggable
  },
  data() {
    return {
      packetId: null,
      studyId: this.$route.params.studyId,
      formId: this.$route.params.formId,
      studyData: {},
      editFormNameInput: false,
      defaultFormName: "Form name (click to edit)",
      formName: window.localStorage.getItem("thread-edcFormName") || "Form name (click to edit)",
      savedFormFields: [],
      mode: "default",
      component: "",
      unscheduledPackets: [],
      edcformData: {},
      selectedPackets: "",
      forms: [],
      scheduleFormOptions: [],
      unScheduleFormOptions: [],
      selectedShowOption: 10,
      unSelectedShowOption: 10,
      currentFormList: [],
      currentPage: 1,
      unselectedCurrentPage: 1,
      totalPages: 1,
      unselectedTotalPages: 1,
      formCount: [],
      searchTerm: "",
      packetName: "",
      unselectedFormDisplay: false,
      selectedFormsData: [],
      packetData: [],
      newFormDatas: [],
      notSelectedFormData: [],
      selectedForms: [],
      unSelectedForms: [],
      allUnscheduledPackets: [],
      packet: {},
      remainingForms: [],
      sortMap: {
        formName: "ASC",
        type: null,
        createdBy: null,
        groupName: null,
        stepsCount: null,
        timeToComplete: null,
        modifiedTime: null
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  props: ["formDatas", "notSelectedFormDatas"],
  computed: {
    isEditMode() {
      const editMode = this.component.length > 0 || this.editFormNameInput;
      this.toggleEDCFormEditMode(editMode);
      return editMode;
    },
    isNewPacket() {
      const packetId = this.$route.params.packetId;
      if (Number(packetId) === 0) {
        return true;
      }
      return false;
    }
  },
  methods: {
    getSortedLanguage(languages) {
      return sortBy(languages, [
        function(o) {
          return o.display_name.toLowerCase().trim();
        }
      ]);
    },
    ...mapActions(["toggleEDCFormEditMode"]),

    isFormSelected(formId) {
      const optionIndex = this.selectedFormsData.findIndex(element => element.id === formId);
      if (optionIndex === -1) {
        return false;
      } else {
        return true;
      }
    },
    addRemainingForm() {
      if (this.unselectedCurrentFormList.length == 0) {
        this.unselectedFormDisplay = false;
      }

      this.newFormDatas = this.newFormDatas.concat(this.selectedFormsData);
      this.showForms(this.selectedShowOption);

      this.notSelectedFormData = this.notSelectedFormData.filter(form => {
        const option = this.selectedFormsData.find(selectedForm => selectedForm.id === form.id);
        if (option) {
          return false;
        }
        return true;
      });

      this.selectedFormsData = [];
      this.unselectedFormDisplay = false;

      this.unselectedShowForms(this.unSelectedShowOption);
    },
    addAForm() {
      if (this.unselectedCurrentFormList.length > 0) {
        this.unselectedFormDisplay = true;
      }
    },
    getFormCount(formVal) {
      const optionIndex = this.selectedFormsData.findIndex(element => element.name === formVal.name);
      if (optionIndex === -1) {
        this.selectedFormsData.push(formVal);
      } else {
        this.selectedFormsData.splice(optionIndex, 1);
      }
      this.selectedFormsData = orderBy(this.selectedFormsData, ["name"], ["asc"]);
    },
    savePackets(autoSave = false) {
      if (this.packetName == "") {
        if (!autoSave) {
          toastr.error("Packet Name is required.");
        }
        return Promise.reject();
      }

      if (this.newFormDatas.length === 0) {
        if (!autoSave) {
          toastr.error("At least one study form is required to save this packet. Add a form.");
        }
        return Promise.reject();
      }

      const unscheduledForms = [];
      for (let i = 0; i < this.newFormDatas.length; i++) {
        unscheduledForms.push({ formId: this.newFormDatas[i].id });
      }

      this.packetData = {
        name: this.packetName,
        unscheduledForms
      };

      return this.$api
        .postUnscheduledPacketFactV2(this.studyId, this.packetData)
        .then(response => {
          if (!autoSave) {
            this.$toastr.success("Packet saved successfully");
          }
          return response;
        })
        .catch(error => {
          if (error.body.message) {
            if (!autoSave) {
              this.$toastr.error(error.body.message);
            }
          } else {
            if (!autoSave) {
              this.$toastr.error("Unable to save this Packet");
            }
          }
          return Promise.reject();
        });
    },
    updatePacket(autoSave = false) {
      if (this.packetName == "") {
        if (!autoSave) {
          toastr.error("Packet Name is required.");
        }
        return Promise.reject();
      }

      if (this.newFormDatas.length === 0) {
        if (!autoSave) {
          toastr.error("At least one study form is required to save this packet. Add a form.");
        }
        return Promise.reject();
      }

      const unscheduledForms = [];
      for (let i = 0; i < this.newFormDatas.length; i++) {
        unscheduledForms.push({ formId: this.newFormDatas[i].id });
      }

      this.packetData = {
        name: this.packetName,
        unscheduledForms
      };

      return this.$api
        .updateUnscheduledPacketFactV2(this.packetId, this.studyId, this.packetData)
        .then(response => {
          if (!autoSave) {
            this.$toastr.success("Updated the packet successfully");
          }
          return response;
        })
        .catch(error => {
          if (error.body.message) {
            if (!autoSave) {
              this.$toastr.error(error.body.message);
            }
          } else {
            if (!autoSave) {
              this.$toastr.error("Unable to save this Packet");
            }
          }
          return Promise.reject();
        });
    },
    showForms(selectedShowOption, stayOnSamePage) {
      this.totalPages = ceil(this.newFormDatas.length / selectedShowOption) === 0 ? 1 : ceil(this.newFormDatas.length / selectedShowOption);
      this.selectedForms = [];
      let start = 0;
      let end = selectedShowOption;
      for (let index = 0; index < this.totalPages; index++) {
        this.selectedForms.push(slice(this.newFormDatas, start, end));
        start += selectedShowOption;
        end += selectedShowOption;
      }
      if (!this.scheduleFormOptions || !this.scheduleFormOptions.length) {
        for (let index = 1; index <= this.totalPages; index++) {
          this.scheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      const oldPage = this.currentPage;
      if (stayOnSamePage) {
        if (!this.selectedForms[oldPage - 1]) {
          this.currentPage = oldPage - 1;
        }
      } else {
        this.currentPage = 1;
      }
      this.currentFormList = this.selectedForms[this.currentPage - 1];
    },
    prevPage() {
      if (this.currentPage <= this.totalPages) {
        this.currentPage -= 1;
        this.currentFormList = this.selectedForms[this.currentPage - 1];
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentFormList = this.selectedForms[this.currentPage];
        this.currentPage += 1;
      }
    },
    unselectedShowForms(unSelectedShowOption) {
      this.unselectedTotalPages = ceil(this.notSelectedFormData.length / unSelectedShowOption) === 0 ? 1 : ceil(this.notSelectedFormData.length / unSelectedShowOption);
      this.unSelectedForms = [];
      let start = 0;
      let end = unSelectedShowOption;
      for (let index = 0; index < this.unselectedTotalPages; index++) {
        this.unSelectedForms.push(slice(this.notSelectedFormData, start, end));
        start += unSelectedShowOption;
        end += unSelectedShowOption;
      }
      if (!this.unScheduleFormOptions || !this.unScheduleFormOptions.length) {
        for (let index = 1; index <= this.unselectedTotalPages; index++) {
          this.unScheduleFormOptions.push({
            value: index * 10,
            text: `Show ${index * 10} items`
          });
        }
      }
      this.unselectedCurrentPage = 1;
      this.unselectedCurrentFormList = this.unSelectedForms[this.unselectedCurrentPage - 1];
    },
    unselectedPrevPage() {
      if (this.unselectedCurrentPage <= this.unselectedTotalPages) {
        this.unselectedCurrentPage -= 1;
        this.unselectedCurrentFormList = this.unSelectedForms[this.unselectedCurrentPage - 1];
      }
    },
    unselectedNextPage() {
      if (this.unselectedCurrentPage < this.unselectedTotalPages) {
        this.unselectedCurrentFormList = this.unSelectedForms[this.unselectedCurrentPage];
        this.unselectedCurrentPage += 1;
      }
    },
    removeFormFromSelectedForms(form) {
      if (!form) {
        return;
      }
      const formToDeleteIndex = this.newFormDatas.findIndex(selectedForms => selectedForms.id == form.id);
      this.newFormDatas.splice(formToDeleteIndex, 1);
      this.showForms(this.selectedShowOption, true);

      this.notSelectedFormData.push(form);
      this.unselectedShowForms(this.unSelectedShowOption);
    },
    getEDCFormDetails() {
      return this.$api
        .getEDCFormsList(this.studyId)
        .then(response => {
          this.allForms = response.body;
          this.allForms = orderBy(this.allForms, ["name"], ["asc"]);
          this.forms = this.allForms;

          this.forms.forEach((form, index) => {
            const data = form;
            data.index = index + 1;
          });
          this.showForms(this.selectedShowOption);
        })
        .catch(() => {
          this.$toastr.error("Error in getting EDC Forms");
        });
    },
    getUnscheduledPackets() {
      return this.$api
        .getUnscheduledPacketsFact(this.studyId)
        .then(response => {
          this.unscheduledPackets = response.body;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Unscheduled Packets");
        });
    },
    getUnscheduledPacketById() {
      if (this.packetId) {
        return this.$api
          .getUnscheduledPacketFactV3(this.packetId, this.studyId)
          .then(response => {
            this.packet = response.body;
          })
          .catch(() => {
            this.$toastr.error("Error in getting Unscheduled Packets");
          });
      }
    },
    findUnSelectedFormInPacket() {
      const array1 = this.packet.unscheduledForms;
      const array2 = _.cloneDeep(this.forms);

      for (let i = 0; i < array2.length; i++) {
        for (let j = 0; j < array1.length; j++) {
          if (i < array2.length && array2[i].id === array1[j].id) {
            array2.splice(i, 1);
          }
        }
      }
      this.remainingForms = array2;
    },
    getLanguagesString(formLanguages) {
      // formLanguages should be an array of objects.

      if (formLanguages instanceof Array && formLanguages.length) {
        const languageNamesArray = formLanguages.map(language => language.display_name || "");
        return languageNamesArray.join(", ");
      }

      return "";
    },
    onDragEnd() {
      const currentFormsLength = this.currentFormList.length;
      const start = (this.currentPage - 1) * this.selectedShowOption;
      let startCurrentList = 0;

      for (let i = start; i < start + currentFormsLength; i++) {
        this.newFormDatas.splice(i, 1, this.currentFormList[startCurrentList]);
        startCurrentList++;
      }

      this.showForms(this.selectedShowOption, true);
    },
    getMilestoneNamesString(form) {
      if (form.milestonesIds && form.milestonesIds.length) {
        return form.milestonesIds.join(", ");
      }
      return "";
    },
    getLastModifiedTime(form) {
      if (form.modifiedTime) {
        const modifiedTimeMoment = moment(form.modifiedTime, "YYYY-MM-DD HH:mm:ss");
        return modifiedTimeMoment.format("D MMM YYYY");
      }
      return "";
    },
    onSaveAndExit() {
      if (this.packetId == 0) {
        this.savePackets().then(() => {
          this.$router.push({
            name: this.$route.name == "study-create-edit-packet" ? "study-activities" : "forms-list",
            params: { studyId: this.studyId }
          });
        });
      } else if (this.packetId) {
        this.updatePacket().then(() => {
          this.$router.push({
            name: this.$route.name == "study-create-edit-packet" ? "study-activities" : "forms-list",
            params: { studyId: this.studyId }
          });
        });
      }
    },
    onSaveAndSchedule(autoSave = false) {
      if (this.packetId == 0) {
        this.savePackets(autoSave).then(response => {
          const packetId = response.body.id;
          this.$router.push({
            name: this.$route.name == "study-create-edit-packet" ? "study-schedule-packet" : "schedule-packet",
            params: { studyId: this.studyId, packetId }
          });
        });
      } else if (this.packetId) {
        this.updatePacket(autoSave).then(() => {
          if (!autoSave) {
            // TODO Add a new route for the schedules page push that route here.
            this.$router.push({
              name: this.$route.name == "study-create-edit-packet" ? "study-schedule-packet" : "schedule-packet",
              params: { studyId: this.studyId, packetId: this.packetId }
            });
          }
        });
      }
    },
    onCancelAddingForms() {
      this.unselectedFormDisplay = false;
      this.selectedFormsData = [];
    },
    sortUnselectedFormData(columnName, order) {
      this.sortMap[columnName] = order;
      let columnType = "string";
      if (columnName == "stepsCount" || columnName == "timeToComplete") {
        columnType = "number";
      }
      if (columnName == "modifiedTime") {
        columnType = "date";
      }
      if (columnType == "string") {
        this.sortByString(columnName, order);
      } else if (columnType == "number") {
        this.sortByNumber(columnName, order);
      } else if (columnType == "date") {
        this.sortByDate(columnName, order);
      }
      this.unselectedShowForms(this.unSelectedShowOption);
      this.$forceUpdate();
    },
    sortByString(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            //sort string ascending
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          const nameA = a[columnName] && a[columnName].toLowerCase();

          const nameB = b[columnName] && b[columnName].toLowerCase();
          if (nameA < nameB) {
            return 1;
          }
          if (nameA > nameB) {
            return -1;
          }
          return 0;
        });
      }
    },
    sortByNumber(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          return a[columnName] - b[columnName];
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          return b[columnName] - a[columnName];
        });
      }
    },
    sortByDate(columnName, order) {
      if (order == "ASC") {
        this.notSelectedFormData.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateA - dateB;
        });
      } else {
        this.notSelectedFormData.sort((a, b) => {
          const dateA = new Date(a[columnName] && a[columnName]);

          const dateB = new Date(b[columnName] && b[columnName]);
          return dateB - dateA;
        });
      }
    },
    toggleSortForUnselectedFormData(columnName) {
      if (this.sortMap[columnName] == null || this.sortMap[columnName] == "DESC") {
        this.sortMap[columnName] = "ASC";
      } else {
        this.sortMap[columnName] = "DESC";
      }

      this.sortUnselectedFormData(columnName, this.sortMap[columnName]);
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.onSaveAndSchedule(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  mounted() {
    this.packetId = this.$route.params.packetId;
    if (!this.isNewPacket) {
      Promise.all([this.getUnscheduledPacketById(), this.getEDCFormDetails()]).then(() => {
        // this.packet = this.unscheduledPackets.find(
        //   unscheduledPacket => unscheduledPacket.id === this.packetId
        // );
        const mode = this.$route.params.mode;
        if (mode == "copy") {
          this.packetName = this.packet.name + " Copy";
          this.packetId = 0;
        } else {
          this.packetName = this.packet.name;
        }
        this.findUnSelectedFormInPacket();
        this.newFormDatas = this.packet.unscheduledForms;
        this.showForms(this.selectedShowOption);

        this.notSelectedFormData = this.remainingForms;
        this.unselectedShowForms(this.unSelectedShowOption);
      });
    } else {
      this.getEDCFormDetails().then(() => {
        this.newFormDatas = this.formDatas || [];
        this.notSelectedFormData = this.notSelectedFormDatas || this.forms;

        this.showForms(this.selectedShowOption);
        this.unselectedShowForms(this.unSelectedShowOption);
      });
    }
    this.startAutoSave();
  },
  beforeRouteLeave(to, from, next) {
    this.onSaveAndSchedule(true);
    setTimeout(() => {
      next();
    }, 100);
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
.sortUp {
  position: absolute;
  margin-top: -3px;
  padding-left: 4px;
  width: 0;
  height: 0;
  background: transparent;
  border-top-width: 0;
  cursor: pointer;
}
.sortDown {
  position: absolute;
  padding-left: 4px;
  width: 0;
  height: 0;
  cursor: pointer;
  top: 71px;
  z-index: 1;
}
.main-container {
  background-color: #f5f6f7 !important;
  height: 100% !important;
  min-height: 100vh;
}

.pt-55 {
  padding-top: 55px !important;
}

.pr-65 {
  padding-right: 65px !important;
}

.center-area {
  z-index: 90;
}

.dataTables_search input {
  width: 96%;
  height: 36px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
}

.tableBg1 {
  background-color: #ffffff !important;
  padding: 24px 20px 0px 20px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: none;
  width: 100%;
  border-top: solid 1px #e4e8eb;
  border-left: solid 1px #e4e8eb;
  border-right: solid 1px #e4e8eb;
}
.tableBg2 {
  background-color: #ffffff !important;
  padding: 24px 20px 0px 20px !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top: none;
  width: 100%;
  border-left: 1px solid #d3dfe4;
  border-right: 1px solid #d3dfe4;
}
.tableBg3 {
  background-color: #ffffff !important;
  padding: 10px 20px 14px 20px !important;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border: 1px solid #d3dfe4;
}

.noOfFormsText {
  width: 172px;
  height: 24px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
}

.noOfForms {
  font-weight: bold;
  color: #f16559;
  padding-right: 5px;
}

.packet-name-box {
  width: 305px;
  height: 30px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
}

.form-title {
  font-size: 11px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.18;
  letter-spacing: normal;
  color: #b0bac9;
}

.form-name {
  width: 300px;
  height: 24px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #4c8ce4 !important;
  vertical-align: baseline;
}

/*checkbox data*/
input[type="checkbox"] + span {
  display: block;
}

input[type="checkbox"] + span:before {
  content: "\2714";
  border: 0.1em solid #d3dfe4;
  border-radius: 3px;
  width: 21px;
  display: inline-block;
  height: 21px;
  padding-left: 5px;
  margin-right: 7px;
  color: transparent;
  background-color: #fff;
}

input[type="checkbox"]:checked + span:before {
  background-color: #4c8ce4;
  border: 0.1em solid #4c8ce4;
  color: #fff;
  font-size: 14px;
  padding-bottom: 5px;
}

.pagination {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 13px;
  line-height: 28px !important;
  color: #4a4a4a;
  padding-left: 11px !important;
}

.pagination2 {
  width: 40px;
  height: 32px;
  background-color: #ffffff;
  font-size: 13px;
  line-height: 28px !important;
  color: #4a4a4a;
  padding-left: 6px !important;
}

.arrow-icon {
  width: 32px;
  height: 32px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #e4e8eb;
  text-align: center;
  font-size: 23px;
  line-height: 10px !important;
  color: #e4e8eb;
}

.cursor-pointer {
  cursor: pointer;
}

.downArrow {
  background-image: url("/static/img/down-arrow.png") !important;
  background-size: 16px 16px;
  background-position: 95% 50% !important;
  width: 135px;
}

.buttons {
  width: 127px;
  height: 36px;
  border-radius: 100px;
}

.bt-pos {
  float: right;
}
.can-btn-text {
  height: 20px;
  font-size: 15px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.43;
  letter-spacing: normal;
  color: #4c8ce4;
}

.required {
  color: #ff0000;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
}

.Vector {
  fill: #b0bac9;
  vertical-align: top;
  cursor: pointer;
}
.Vector:hover {
  fill: #0056b3;
}

.add-form {
  width: 120px;
  background-repeat: no-repeat;
  height: 30px;
  background-position: 2% 50%;
  text-align: center;
  padding-left: 25px;
  background-size: 24px 24px;
  background-image: url("/static/img/activity-configurator/plus.png");
}
.studys_schedule {
  font-size: 12px;
}
.disabledPagination {
  pointer-events: none;
}
.btn-primary-save {
  color: #fff;
  background-color: #b0bac9;
}

.create-edit-packet-table {
  &__language-box {
    width: 35px;
    height: 24px;
    font-size: 14px;
    font-weight: bold;
    color: #4c8ce4;
    border: 1px solid #d3dee3 !important;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    line-height: 22px;
    &:focus {
      outline: none;
    }
  }

  &__language-pop-over-container {
    /* width: 210px; */
    /* height: 258px; */
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    overflow-y: scroll;
    max-height: 258px;
    scrollbar-width: thin; /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */

    &::-webkit-scrollbar {
      width: 5px; /* width of the entire scrollbar */
      max-height: 15%;
    }
    &::-webkit-scrollbar-track {
      background: transparent; /* color of the tracking area */
    }
    &::-webkit-scrollbar-thumb {
      background-color: #b0bac9; /* color of the scroll thumb */
      border-radius: 20px; /* roundness of the scroll thumb */
      border: 3px solid transparent; /* creates padding around scroll thumb */
    }
  }

  &__languages-list {
    list-style: none;
    padding-left: 15px;
    padding-top: 9px;
  }

  &__languages-list-item {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.14;
    letter-spacing: normal;
    color: #000000;
  }
}

.drag-icon-container {
  text-align: center;
}

.remove-form-icon {
  cursor: pointer;
  vertical-align: middle;
  padding: 3px;
  border: 1px solid #d3dfe4;
  background: #d3dfe4;
  opacity: 0.6;
  border-radius: 3px;
  margin-right: 5px;
}

.create-edit-packet-page {
  &__order-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }
  }

  &__add-forms-table {
    tr {
      height: 41px;
      border-bottom: 1px solid #d3dfe4;
    }

    input[type="checkbox"] {
      height: 21px;
      width: 21px;
    }
  }

  &__order-table,
  &__add-forms-table {
    th {
      font-family: "RobotoRegular";
      font-size: 11px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2.18;
      letter-spacing: normal;
      color: #b0bac9;
    }

    td {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }

    .activity_type {
      font-size: 12px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 2;
      letter-spacing: normal;
      color: #000000;
    }
  }
}
</style>

<style lang="scss">
/* DO NOT WRITE STYLES HERE. THIS IS NOT SCOPED AND THERE WAS A NEED TO MODIFY STYLING OF BOOTSTRAP_VUE */
/* COMPONENT. */
#create-edit-packet-page {
  .popover {
    width: 210px !important;
    margin: 0 !important;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
    background-color: #ffffff;
    left: -8px !important;
    border: none;

    .popover-body {
      margin: 0 !important;
      padding: 0 !important;
    }
  }
}
.forms-table {
  border-top: none !important;
}
</style>
